import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FolderManagerModal = ({ show, handleClose, folders, onCreateFolder, onRenameFolder, onDeleteFolder }) => {
  const [newFolderName, setNewFolderName] = useState('');
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [renamedFolderName, setRenamedFolderName] = useState('');

  useEffect(() => {
    if (selectedFolder) {
      setRenamedFolderName(selectedFolder.name || '');
    }
  }, [selectedFolder]);

  const handleCreateFolder = () => {
    if (newFolderName.trim() === '') {
      toast.error('Folder name cannot be empty!', { position: "bottom-left" });
      return;
    }
    onCreateFolder({ name: newFolderName });
    setNewFolderName('');
  };

  const handleRenameFolder = () => {
    if (!selectedFolder) {
      toast.error('No folder selected for renaming!', { position: "bottom-left" });
      return;
    }
    if (renamedFolderName.trim() === '') {
      toast.error('Folder name cannot be empty!', { position: "bottom-left" });
      return;
    }
    onRenameFolder({ ...selectedFolder, name: renamedFolderName });
    setSelectedFolder(null);
    setRenamedFolderName('');
  };

  const handleDeleteFolder = () => {
    if (!selectedFolder) {
      toast.error('No folder selected for deletion!', { position: "bottom-left" });
      return;
    }
    onDeleteFolder(selectedFolder.folder_id);
    setSelectedFolder(null);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Folder Management</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formNewFolderName">
            <Form.Label>New Folder Name</Form.Label>
            <Form.Control
              type="text"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
              placeholder="Enter new folder name"
            />
          </Form.Group>
          <Button variant="primary" onClick={handleCreateFolder} className="mt-2 mx-0">
            Add Folder
          </Button>
        </Form>
        <hr className='mt-1 mb-3' />
        <Form>
          <Form.Group controlId="formSelectFolder">
            <Form.Label>Select Folder</Form.Label>
            <Form.Control
              as="select"
              value={selectedFolder ? selectedFolder.folder_id : ''}
              onChange={(e) => {
                const folder = folders.find(f => f.folder_id === parseInt(e.target.value));
                setSelectedFolder(folder);
              }}
            >
              <option value="" disabled>Select folder...</option>
              {folders.map(folder => (
                <option key={folder.folder_id} value={folder.folder_id}>
                  {folder.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          {selectedFolder && (
            <>
              <Form.Group controlId="formRenameFolderName" className="mt-2">
                <Form.Label>Rename Folder</Form.Label>
                <Form.Control
                  type="text"
                  value={renamedFolderName}
                  onChange={(e) => setRenamedFolderName(e.target.value)}
                  placeholder="Enter new folder name"
                />
              </Form.Group>
              <div className="mt-2 d-flex justify-content-between align-items-center">
                  <Button className='mx-0' variant="primary" onClick={handleRenameFolder}>
                    <i className="bi bi-pencil me-1"></i>Rename Folder
                  </Button>
                  <Button className='mx-0' variant="danger" onClick={handleDeleteFolder}>
                    <i className="bi bi-trash me-1"></i>Delete Folder
                  </Button>
              </div>
            </>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FolderManagerModal;
